import script from "./FieldEditor.vue?vue&type=script&setup=true&lang=js"
export * from "./FieldEditor.vue?vue&type=script&setup=true&lang=js"

import "./FieldEditor.vue?vue&type=style&index=0&id=b0a9b712&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b0a9b712"]])

export default __exports__